<div class="subs-root">
  {{#isPCWeb}}
  <div class="subs-shadow"></div>
  {{/isPCWeb}}
  <div class="subs-contents {{#isPCWeb}}subs-contents-floating{{/isPCWeb}}">
    {{#isPC}}
    <div class="subs-header">
      <h2 class="subs-title">부스터 정기결제</h2>
      <a href="#" data-booster-click="close" class="subs-close">닫기</a>
    </div>
    {{/isPC}}
    <div class="subs-section">
      <div class="subs-status">
        <h3 class="subs-title">정기결제 상품 이용 정보</h3>
        <table class="subs-status-tbl">
          <tbody>
            <tr class="subs-my-membership">
              <th>이용상품</th>
              <td>{{subscription}}</td>
            </tr>
            <tr>
              <th>최근 결제 금액</th>
              <td>{{addComma lastPaidAmount}}원 {{lastPaidDetail}}</td>
            </tr>
            <tr>
              <th>다음 결제 예정일</th>
              <td>{{nextPaymentDate}}</td>
            </tr>
          </tbody>
        </table>
        <div class="subs-actions">
          <!-- #1-1. 모바일 게임 접속 / 구글에서 결제 -->
          {{#if (equal platformDetail "mobile/google-class")}}
          <div class="subs-notify">
            ※ 해지는 구글 스토어 구독관리에서 할 수 있습니다.
          </div>
          {{#isAndroid}}
          <div class="subs-btns">
            <a href="https://play.google.com/store/account/subscriptions" class="subs-btn subs-btn-bold">정기 결제 해지하기</a>
          </div>
          {{/isAndroid}}
          {{/if}}

          <!-- #1-2. 모바일 게임 접속 / 애플에서 결제 -->
          {{#if (equal platformDetail "mobile/ios-class")}}
          <div class="subs-notify">
            ※ 해지는 앱 스토어 구독관리에서 할 수 있습니다.
          </div>
          {{#isIOS}}
          <div class="subs-btns">
            <a href="https://apps.apple.com/account/subscriptions" class="subs-btn subs-btn-bold">정기 결제 해지하기</a>
          </div>
          {{/isIOS}}
          {{/if}}

          <!-- #2. PC 게임 접속 / PC에서 결제 -->
          {{#if (equal platformDetail "pc-game/pc-class")}}
          <div class="subs-notify">
            ※ 결제 수단 변경은 "웹 &gt; 클래스 &gt; 결제정보보기" 에서 가능합니다.
          </div>
          <div class="subs-btns">
            {{#if isCancelling }}
            <a href="#" data-booster-click="rollback" class="subs-btn subs-btn-bold">부스터 해지 예약 취소</a>
            {{else}}
            <a href="#" data-booster-click="unsubscribe" class="subs-btn subs-btn-bold">부스터 해지 예약</a>
            {{/if}}
          </div>
          {{/if}}

          <!-- #3-1. PC 게임 접속 / 구글에서 결제 -->
          {{#if (equal platformDetail "pc-game/google-class")}}
          <div class="subs-notify">
            ※ 해지는 구글 스토어 구독관리에서 할 수 있습니다.
          </div>
          {{/if}}

          <!-- #3-2. PC 게임 접속 / 애플에서 결제 -->
          {{#if (equal platformDetail "pc-game/ios-class")}}
          <div class="subs-notify">
            ※ 해지는 앱 스토어 구독관리에서 할 수 있습니다.
          </div>
          {{/if}}

          <!-- #4. PC 웹 접속 / PC에서 결제 -->
          {{#if (equal platformDetail "pc-web/pc-class")}}
          <div class="subs-btns">
            <a href="#" data-booster-click="changePayment" class="subs-btn">결제수단 변경</a>
            {{#if isCancelling }}
            <a href="#" data-booster-click="rollback" class="subs-btn subs-btn-bold">부스터 해지 예약 취소</a>
            {{else}}
            <a href="#" data-booster-click="unsubscribe" class="subs-btn subs-btn-bold">부스터 해지 예약</a>
            {{/if}}
          </div>
          {{/if}}

          <!-- #5-1. PC 웹 접속 / 구글에서 결제 -->
          {{#if (equal platformDetail "pc-web/google-class")}}
          <div class="subs-notify">
            ※ 해지는 구글 스토어 구독관리에서 할 수 있습니다.
          </div>
          {{/if}}

          <!-- #5-2. PC 웹 접속 / 애플에서 결제 -->
          {{#if (equal platformDetail "pc-web/ios-class")}}
          <div class="subs-notify">
            ※ 해지는 앱 스토어 구독관리에서 할 수 있습니다.
          </div>
          {{/if}}
        </div><!-- // subs-section -->
      </div>
      <div class="subs-history">
        <h3 class="subs-title">정기결제 내역</h3>
        <table class="subs-history-tbl">
          <thead>
            <tr>
              <th class="subs-hc1">결제일</th>
              <th class="subs-hc2">이용상품</th>
              <th class="subs-hc3">결제금액</th>
            </tr>
          </thead>
          <tbody>
            {{#history}}
            <tr>
              <td class="subs-hc1">{{{paidDate}}}</td>
              <td class="subs-hc2">{{subscription}}</td>
              <td class="subs-hc3">{{#if paidAmount}}{{addComma paidAmount}}원{{/if}}</td>
            </tr>
            {{/history}}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
